import { oktaConfig } from "../config/OktaConfig";
import { OktaAuth } from "@okta/okta-auth-js";

export const oktaAuth = new OktaAuth(oktaConfig);